import { Profanity, ProfanityOptions } from '@2toad/profanity';

import { Injectable } from '@angular/core';

import BadWordsNext from 'bad-words-next';

// taken from https://github.com/maxwellium/cologne-phonetic/blob/main/src/index.ts
const rules: [RegExp, string][] = [
  // substitutions
  [/ä/g, 'a'],
  [/ö/g, 'o'],
  [/ü/g, 'u'],
  [/ß/g, '8'],
  [/[^a-z]/g, ''],
  // complex rules
  [/[dt](?![csz])/g, '2'], // [csz] are replaced soon, so this
  [/[dt](?=[csz])/g, '8'], // needs to exec early
  [/[ckq]x/g, '88'],
  [/[sz]c/g, '88'], // double digits will be reduced later -- but this is easier to debug ;)
  [/^c(?=[ahkloqrux])/, '4'],
  [/^c/, '8'],
  [/c(?=[ahkoqux])/, '4'],
  [/c$/, '4'],
  [/x/g, '48'],
  [/p(?!h)/g, '1'],
  [/p(?=h)/g, '3'],
  // simple rules
  [/h/g, ''],
  [/[aeijouy]/g, '0'],
  [/b/g, '1'],
  [/[fvw]/g, '3'],
  [/[gkq]/g, '4'],
  [/l/g, '5'],
  [/[mn]/g, '6'],
  [/r/g, '7'],
  [/[csz]/g, '8'],
  // modifiers
  [/([^\w\s])|(.)(?=\2)/g, ''], // reduce consecutive duplicates to one
  [/\B0/g, ''], // remove 0s except for first char
];

export const colognePhonetic = (phrase: string): string =>
  rules.reduce((kph, [search, replace]) => kph.replace(search, replace), phrase.toLowerCase());

const options = new ProfanityOptions();
options.wholeWord = true;
const profanity = new Profanity(options);

export const badWordsDe = [
  'anal',
  'analritter',
  'arsch',
  'arschficker',
  'arschlecker',
  'arschloch',
  'bimbo',
  'bratze',
  'bumsen',
  'bonze',
  'dödel',
  'doedel',
  'faekal',
  'fäkal',
  'flachwichser',
  'fick',
  'ficken',
  'flittchen',
  'fotze',
  'fratze',
  'fut',
  'hackfresse',
  'hure',
  'hurensohn',
  'ische',
  'kackbratze',
  'kack',
  'kacke',
  'kacken',
  'kackwurst',
  'kampflesbe',
  'kanake',
  'kimme',
  'lecken',
  'lümmel',
  'lummel',
  'luemmel',
  'MILF',
  'missgeburt',
  'möpse',
  'moepse',
  'morgenlatte',
  'möse',
  'moese',
  'mufti',
  'muschi',
  'nackt',
  'neger',
  'nippel',
  'nutte',
  'onanieren',
  'orgasmus',
  'pädophil',
  'pimmel',
  'pimpern',
  'pinkeln',
  'pissen',
  'pisser',
  'popel',
  'poppen',
  'porn',
  'porno',
  'reudig',
  'rosette',
  'schabracke',
  'schlampe',
  'scheiße',
  'scheisse',
  'scheiss',
  'scheisz',
  'scheisser',
  'schiesser',
  'schnackeln',
  'schwanzlutscher',
  'schwanz',
  'selbstmord',
  'mord',
  'lutscher',
  'lutsch*',
  'schwuchtel',
  'tittchen',
  'titten',
  'toeten',
  'töten',
  'vögeln',
  'voegeln',
  'vollpfosten',
  'wichse',
  'wichsen',
  'wichser',
  'wix',
  'schas',
];

export const badWordsKrupion = [
  'aasig',
  'abartig',
  'Abartigkeit',
  'Abdecker',
  'Abfallbeseitigung',
  'abfressen',
  'Abhub',
  'abnormal',
  'Abnormität',
  'Abort',
  'abprotzen',
  'absaufen',
  'abschlachten',
  'abschlagen',
  'abspritzen',
  'abstechen',
  'absterben',
  'abstoßend',
  'abwichsen',
  'abwürgen',
  'Abzocker',
  'Adenom',
  'Adolf',
  'affengeil',
  'After',
  'Agitation',
  'Agitator',
  'Agitatorin',
  'agitieren',
  'Agonie',
  'AKW',
  'Albino',
  'Alki',
  'Alkoholiker',
  'Altenheim',
  'Amin',
  'Amok',
  'Amoklauf',
  'Amokläufer',
  'Anarchie',
  'Anarchismus',
  'Anarchist',
  'Anarcho',
  'anekeln',
  'anfressen',
  'Anmache',
  'anmotzen',
  'annektieren',
  'Anomalie',
  'Anranzer',
  'anscheißen',
  'Anus',
  'anwidern',
  'Apartheid',
  'Apokalypse',
  'Arier',
  'Armageddon',
  'Armeekorps',
  'Armenhaus',
  'armselig',
  'Arsch',
  'Arschficker',
  'Arschgeige',
  'Arschkarte',
  'Arschloch',
  'Artillerie',
  'asozial',
  'Asoziale',
  'Asozialer',
  'Asozialität',
  'Assad',
  'Assi',
  'Asylant',
  'Asylantin',
  'Atombombe',
  'Atombunker',
  'Atommacht',
  'Atomstopp',
  'Attentat',
  'Attentäter',
  'Auferstehung',
  'auffressen',
  'ausgezehrt',
  'Ausländer',
  'Ausländerin',
  'ausmerzen',
  'ausmisten',
  'Aussatz',
  'aussaufen',
  'ausscheißen',
  'ausschleimen',
  'aussterben',
  'Auswuchs',
  'Auswurf',
  'Auszehrung',
  'Autopsie',
  'Babyklappe',
  'Bahre',
  'ballern',
  'Bandenchef',
  'Bankraub',
  'Bankrotteur',
  'Barbarei',
  'Bastard',
  'Bauernopfer',
  'bedeppert',
  'bedrücken',
  'Befall',
  'Befreiungskriege',
  'begaunern',
  'begraben',
  'behämmert',
  'Behinderte',
  'Behinderter',
  'Beinhorn',
  'Beischlaf',
  'beischlafen',
  'bekümmern',
  'belutschen',
  'Beschäler',
  'beschimpfen',
  'beschissen',
  'besoffen',
  'bestialisch',
  'Bestürzung',
  'besudeln',
  'Betriebsunfall',
  'Betrübnis',
  'betrunken',
  'Bettelei',
  'betteln',
  'Bewaffnung',
  'bezecht',
  'Bimbo',
  'Binding',
  'Birkenau',
  'Bisswunde',
  'Blage',
  'Blähung',
  'Blattern',
  'blöd',
  'Blödian',
  'Blutbad',
  'Blutbeule',
  'Blutschande',
  'blutschänderisch',
  'Blutstuhl',
  'Blutsturz',
  'Bluttat',
  'Bölkow',
  'Bombardement',
  'bombardieren',
  'Bombe',
  'bomben',
  'Bordtoilette',
  'Brandmal',
  'Brandstätte',
  'Brandstifter',
  'Braunau',
  'Breker',
  'brennend',
  'Brigadier',
  'Bruchbude',
  'brutal',
  'Brutalität',
  'Buchenwald',
  'Buckel',
  'bumsen',
  'Bundeswehr',
  'Bürgerkrieg',
  'Buschneger',
  'Buschnegerin',
  'Busen',
  'Camorra',
  'Cannabis',
  'Ceausescu',
  'Chemotherapie',
  'clean',
  'dahinsterben',
  'dämlich',
  'Darmwind',
  'dealen',
  'Dealer',
  'Deformation',
  'Degeneration',
  'dement',
  'Despotie',
  'Detonator',
  'Diarrhö',
  'Domina',
  'doof',
  'Dope',
  'dopen',
  'Dreck',
  'Dreckding',
  'Dreckfink',
  'Drecksack',
  'Drecksau',
  'Drecksding',
  'Dreckskerl',
  'Dreckstück',
  'Dresche',
  'Dritte Welt',
  'Dung',
  'Dünnpfiff',
  'Dünnschiss',
  'Durchfall',
  'durchtrieben',
  'Dysontogenie',
  'Ecstasy',
  'ehrlos',
  'Eierkopf',
  'eingeboren',
  'Eingeborene',
  'Eingeborenensprache',
  'Eingeborener',
  'Eingeborne',
  'Eingeborner',
  'Eingeweide',
  'einkerkern',
  'Einschuss',
  'Ekel',
  'ekelhaft',
  'ekeln',
  'eklig',
  'Elektroschock',
  'elendig',
  'eliminieren',
  'Emanze',
  'Endkampf',
  'entarten',
  'Entartung',
  'enterben',
  'entseelt',
  'entstellen',
  'Entstellung',
  'entvölkern',
  'erbarmungslos',
  'Erbsünde',
  'erleiden',
  'ermorden',
  'Erotiker',
  'erschachern',
  'erstechen',
  'Ertrinken',
  'erwerbslos',
  'Erzgauner',
  'Eskimo',
  'Eskimofrau',
  'eskimoisch',
  'Eskimoische',
  'Esserei',
  'Eugenik',
  'Exkommunikation',
  'Exorzist',
  'Fadenkreuz',
  'Fallbeil',
  'Farbiger',
  'Faschist',
  'Fascho',
  'Fatzke',
  'faulen',
  'Faulgas',
  'Fäulnis',
  'feig',
  'Feldpost',
  'Fettbauch',
  'Fettkloß',
  'fettleibig',
  'Fettsack',
  'Fettwanst',
  'Feuerball',
  'feuern',
  'ficken',
  'fickerig',
  'fickrig',
  'Fidschi',
  'Filzlaus',
  'fixen',
  'Fixer',
  'Flak',
  'Flatulenz',
  'Flatus',
  'Flegelei',
  'Flennerei',
  'Flugabwehr',
  'Fokker',
  'Folter',
  'foltern',
  'Folterwerkzeug',
  'Fotze',
  'Fotzenlecker',
  'Fraß',
  'Fratze',
  'Frechling',
  'Freier',
  'Freischar',
  'Fremdherrschaft',
  'Frenssen',
  'fressen',
  'Friedhof',
  'frigid',
  'frigide',
  'fristen',
  'Führer',
  'Furz',
  'furzen',
  'furztrocken',
  'Fusel',
  'Fußangel',
  'Gaddafi',
  'gaffen',
  'Galgen',
  'Gammler',
  'Gammlerin',
  'gammlig',
  'Garaus',
  'Garrotte',
  'Gasangriff',
  'Gasmaske',
  'Gasofen',
  'Gastarbeiter',
  'GAU',
  'Gebein',
  'Gebettel',
  'Gebrechen',
  'Geflenne',
  'Gehetze',
  'Geheul',
  'Geifer',
  'geifern',
  'geißeln',
  'Geisterfahrer',
  'geistesgestört',
  'Geistesgestörte',
  'Geistesgestörter',
  'Geistesgestörtheit',
  'geisteskrank',
  'Geleier',
  'Geleitschutz',
  'Geleitzug',
  'Gelichter',
  'Gemauschel',
  'Gendefekt',
  'Genosse',
  'Genossin',
  'Geriatrie',
  'geringschätzig',
  'Gesäß',
  'Geschacher',
  'Geschmeiß',
  'Geseire',
  'Gesindel',
  'Gestammel',
  'gestorben',
  'Gevögel',
  'Gewaltakt',
  'Gewitterziege',
  'Gezanke',
  'Gicht',
  'gieren',
  'Glatze',
  'Glimmstängel',
  'glotzen',
  'Gnadenbrot',
  'Gosse',
  'Gotteslästerung',
  'Grab',
  'Grabbeltisch',
  'Grabmal',
  'grämlich',
  'Granate',
  'Gräuel',
  'Gräueltat',
  'Grauen',
  'grauenhaft',
  'grauenvoll',
  'graus',
  'grausam',
  'Grausamkeit',
  'greinen',
  'Greisenhaupt',
  'Greisin',
  'grenzdebil',
  'Grind',
  'Guerilla',
  'Guerillakämpfer',
  'Hackordnung',
  'Haderer',
  'Haderlump',
  'Hahnenkampf',
  'Hakenbüchse',
  'Hakennase',
  'Halbblut',
  'Harakiri',
  'härmen',
  'Harn',
  'Hasch',
  'Hasenscharte',
  'Hasser',
  'hässig',
  'Haue',
  'hauen',
  'Hausbesetzung',
  'hautfarben',
  'Heckenschütze',
  'Hehlerin',
  'Heidegger',
  'Heimtücke',
  'Heinkel',
  'Henker',
  'herumzigeunern',
  'Herzinfarkt',
  'Hetäre',
  'hinmachen',
  'Hintern',
  'Hinterteil',
  'hirnlos',
  'Hitler',
  'Himmler',
  'Göbbels',
  'goebbels',
  'Homo-Ehe',
  'Hooligan',
  'Hooligans',
  'Höriger',
  'Hosenkacker',
  'Hottentotten',
  'Humpelei',
  'hungern',
  'Hungersnot',
  'Hure',
  'huren',
  'Hurenhaus',
  'Hurenlohn',
  'Hurenviertel',
  'Hurer',
  'Idiotie',
  'Iñaki',
  'Indianer',
  'Indianerbuch',
  'Indianerbüffel',
  'Indianerfrau',
  'Indianergeheul',
  'Indianergeschichte',
  'Indianerhäuptling',
  'Indianerin',
  'Indianerkostüm',
  'Indianerkrapfen',
  'Indianerreservat',
  'Indianerreservation',
  'Indianerroman',
  'indianerrot',
  'Indianerschmuck',
  'Indianersommer',
  'Indianerspiel',
  'Indianersprache',
  'Indianerstamm',
  'Indianertanz',
  'Indianerzelt',
  'indianisch',
  'Indianist',
  'Indianistik',
  'Indianistin',
  'indianistisch',
  'Indio',
  'Indiofrau',
  'Indios',
  'Infamie',
  'Infanterie',
  'Infarkt',
  'Inferno',
  'Invalide',
  'Inzucht',
  'irremachen',
  'Irrenabteilung',
  'Irrenanstalt',
  'Irrenarzt',
  'Irrenärztin',
  'Irrenhaus',
  'Irrenhäusler',
  'Irrenhäuslerin',
  'Irrenpfleger',
  'Irrenpflegerin',
  'Irrenwärter',
  'Irrenwärterin',
  'Irrer',
  'Irrsinn',
  'Irrung',
  'jammervoll',
  'Japs',
  'Jauche',
  'Joint',
  'Judensau',
  'Kacke',
  'kacken',
  'Kacker',
  'Kadaver',
  'Kaffer',
  'kaltmachen',
  'Kameltreiber',
  'Kamikaze',
  'Kämpe',
  'Kanake',
  'Kanaker',
  'Kanakin',
  'Kanalratte',
  'Kannibale',
  'Kanonade',
  'Kastration',
  'Katzenficken',
  'Kauleiste',
  'Keilerei',
  'Khomeini',
  'Kidnapping',
  'kielholen',
  'Kiffer',
  'kill',
  'killen',
  'Killer',
  'Kindesmutter',
  'Kindesraub',
  'Kindesvater',
  'Kindsmutter',
  'Kindsvater',
  'Klapse',
  'Klapsmühle',
  'Kleinwuchs',
  'Klimawandel',
  'Klo',
  'Klosett',
  'Klöten',
  'Knallcharge',
  'Knallkopf',
  'Knallkopp',
  'Knarre',
  'knausrig',
  'Knebel',
  'knebeln',
  'Knebelung',
  'Knechtung',
  'Knilch',
  'knochig',
  'Kokotte',
  'Kokser',
  'Koller',
  'Konkubine',
  'Konterrevolution',
  'Kopftuchmädchen',
  'Kot',
  'Köter',
  'Kotze',
  'kranken',
  'Krätze',
  'Krebs',
  'krebsen',
  'Krebsvorsorge',
  'krepieren',
  'Krieg',
  'Kriegskrüppel',
  'Kriegsschiff',
  'Krüppel',
  'krüppelhaft',
  'krüppelig',
  'krüpplig',
  'Kruzitürken',
  'Ku-Klux-Klan',
  'Kuhdorf',
  'Kümmeltürke',
  'Kümmeltürkin',
  'kupieren',
  'Kuppelei',
  'KZ',
  'Ladino',
  'Laffe',
  'Lähme',
  'Lähmung',
  'Landser',
  'Lebedame',
  'Ledernacken',
  'Leiche',
  'Leichnam',
  'Leimrute',
  'Leitfeuer',
  'letal',
  'Leukämie',
  'Liebedienerei',
  'Liliputaner',
  'Liliputanerin',
  'Loibl',
  'Luder',
  'Luftabwehr',
  'Lügenmaul',
  'Lump',
  'lüstern',
  'Lüstling',
  'Luxusnutte',
  'lynchen',
  'Lynchjustiz',
  'Marktweib',
  'Marodeur',
  'Marter',
  'Marterpfahl',
  'masturbieren',
  'Matrone',
  'maulfaul',
  'Mauschelei',
  'mausetot',
  'Memme',
  'meschugge',
  'Meskalin',
  'Mestize',
  'Mestizin',
  'Metze',
  'Mief',
  'militant',
  'Milosevic',
  'Minenleger',
  'Mischblut',
  'Mischling',
  'Missgeburt',
  'missgestaltet',
  'Misshandlung',
  'Mist',
  'Mistfink',
  'Mitverschulden',
  'mobben',
  'Mobbing',
  'Moder',
  'Mohammedaner',
  'Mohr',
  'Mohrenkopf',
  'mohrenschwarz',
  'Mohrenwäsche',
  'Mohrin',
  'Mongolismus',
  'mongoloid',
  'Mongoloidismus',
  'Mord',
  'morden',
  'MP',
  'Mubarak',
  'Mugabe',
  'Mulatte',
  'Mulattin',
  'Müllwerker',
  'Mumie',
  'Mussolini',
  'Nachsuche',
  'Nagana',
  'Nagelung',
  'Naidoo',
  'Napalm',
  'narbig',
  'Nasenschleim',
  'nässen',
  'Nationalsozialist',
  'Nazi',
  'Nebelkerze',
  'Neger',
  'negerhaft',
  'Negerin',
  'negerisch',
  'Negerkind',
  'Negerkuss',
  'Negermusik',
  'Negersklave',
  'Negersklavin',
  'Negrito',
  'Nickneger',
  'Niedertracht',
  'niederträchtig',
  'Nigger',
  'Nillenflicker',
  'Notleidend',
  'Notstandsgesetz',
  'NS',
  'Nudität',
  'Nutte',
  'obdachlos',
  'Obszönität',
  'Ohrfeige',
  'Ölauge',
  'Ölung',
  'Onanie',
  'onanieren',
  'outen',
  'Pack',
  'PEGIDA',
  'peinigen',
  'Peiniger',
  'Peinigung',
  'Penis',
  'Pennbruder',
  'Penner',
  'Perfidie',
  'pervers',
  'Pfaffe',
  'Phrasendrescher',
  'piesacken',
  'Pillendreher',
  'pinkeln',
  'Pinochet',
  'Pipi',
  'Pisse',
  'pissen',
  'Pisser',
  'Pissnelke',
  'Plattfußindianer',
  'Plattfußindianerin',
  'plebejisch',
  'Plebs',
  'Po',
  'Pobacke',
  'Pöbel',
  'Pöbelei',
  'Pogrom',
  'Polack',
  'Polacke',
  'Polente',
  'Poliomyelitis',
  'Porno',
  'Pornografie',
  'pornografisch',
  'pornographisch',
  'Prärieindianer',
  'Prärieindianerin',
  'Prolet',
  'Prostituierte',
  'Prügel',
  'prügeln',
  'Puebloindianer',
  'Puebloindianerin',
  'Puff',
  'Pup',
  'Pups',
  'pupsen',
  'Putin',
  'quälen',
  'qualvoll',
  'Querdenker',
  'Racheakt',
  'Raffke',
  'Raffsucht',
  'Raid',
  'Raspe',
  'Rasse',
  'Rassentrennung',
  'Rassismus',
  'Raubzug',
  'Reanimation',
  'remmeln',
  'Retortenbaby',
  'Revanchist',
  'Rohheit',
  'Rohrstock',
  'Romni',
  'Rothaut',
  'Rotz',
  'Rotzfahne',
  'rotzfrech',
  'Rotzjunge',
  'Rotznase',
  'Rübensau',
  'Rüpelei',
  'Säbelrasseln',
  'Sadismus',
  'Sadist',
  'sadistisch',
  'Saftsack',
  'Saftschubse',
  'Saftschubser',
  'Sarg',
  'Satan',
  'satanisch',
  'säuisch',
  'schäbig',
  'Schäbigkeit',
  'Schacher',
  'Schacherer',
  'Schacherin',
  'schachern',
  'Schandmal',
  'Scheide',
  'Scheinasylant',
  'Scheinasylantin',
  'Scheiß',
  'Scheißdreck',
  'Scheiße',
  'Scheissen',
  'Scheißer',
  'Scheißerei',
  'Scheißerin',
  'Scheißkerl',
  'schinden',
  'Schinder',
  'Schiss',
  'schizophren',
  'schlagen',
  'Schlägerei',
  'Schlagring',
  'Schlampe',
  'Schleim',
  'schleimig',
  'Schlitzauge',
  'schmierig',
  'Schmutzfink',
  'Schnodder',
  'Schnösel',
  'Schrumpfgermane',
  'Schund',
  'schwachköpfig',
  'Schwanzlutscher',
  'Schweinefraß',
  'Schweinerei',
  'schweinisch',
  'Schwuchtel',
  'schwul',
  'Schwuli',
  'Seemine',
  'Sektion',
  'Selektion',
  'senil',
  'Separatist',
  'Sexualität',
  'sexuell',
  'Sexus',
  'sexy',
  'sex',
  'Shit',
  'shocking',
  'Sinto',
  'Skalp',
  'Skinhead',
  'Sklaverei',
  'Slum',
  'Slums',
  'Sodomie',
  'Sozi',
  'Spacey',
  'Spacken',
  'Spacko',
  'Spagettifresser',
  'Spaghettifresser',
  'Spasti',
  'Spast',
  'Spastiker',
  'Spastikerin',
  'spastisch',
  'Speichellecker',
  'Sperma',
  'Sperrfeuer',
  'Sprengkörper',
  'spucken',
  'Stadtindianer',
  'Stadtindianerin',
  'Stalin',
  'Starfighter',
  'Stechschritt',
  'steinigen',
  'sterben',
  'stockbesoffen',
  'stockbetrunken',
  'Streitmacht',
  'Strieme',
  'Striemen',
  'Stuhlgang',
  'Sudelei',
  'Suharto',
  'Tappert',
  'Tatzeit',
  'taubstumm',
  'Taubstumme',
  'Taubstummenanstalt',
  'Taubstummenlehrer',
  'Taubstummenlehrerin',
  'Taubstummenschule',
  'Taubstummensprache',
  'Taubstummenunterricht',
  'Taubstummer',
  'Taubstummheit',
  'Tellereisen',
  'Terror',
  'Terrorakt',
  'Terrorist',
  'Teufelin',
  'Thorak',
  'Thusnelda',
  'Tierversuch',
  'Tippse',
  'Tod',
  'Todesangst',
  'Töle',
  'Torpedo',
  'Torpedoboot',
  'tot',
  'Tote',
  'töten',
  'totschlagen',
  'Tragbahre',
  'Transpiration',
  'transpirieren',
  'Transuse',
  'Trantüte',
  'Trinker',
  'Tripper',
  'Trottel',
  'Trunkenheit',
  'Tschechei',
  'tuckig',
  'Tumor',
  'Türkenkoffer',
  'Tussis',
  'Tyrann',
  'Tyrannei',
  'Übelstand',
  'Überbein',
  'überfressen',
  'Ulkus',
  'umbringen',
  'Unflat',
  'ungeschlacht',
  'Unrat',
  'unstatthaft',
  'unwert',
  'Urin',
  'urinieren',
  'Vagina',
  'verabscheuen',
  'Verbildung',
  'verblichen',
  'Verbrecher',
  'vergammelt',
  'vernichten',
  'verpissen',
  'verprügeln',
  'verrecken',
  'Verrückte',
  'Verrückter',
  'verschachern',
  'verschissen',
  'versklaven',
  'Versuchstier',
  'Viech',
  'violent',
  'vögeln',
  'volltrunken',
  'Vollzug',
  'Vulva',
  'Waffenlager',
  'Waldbrand',
  'Waldsterben',
  'Walfang',
  'Warze',
  'WC',
  'wegfressen',
  'Wehrmacht',
  'Weib',
  'weibisch',
  'Weibsbild',
  'Westpreußen',
  'Wichse',
  'wichsen',
  'Wichser',
  'Widerling',
  'Wirtschaftsasylant',
  'Wirtschaftsasylantin',
  'Witwe',
  'Witwer',
  'Wutanfall',
  'Wutz',
  'Zeitbombe',
  'Zigeuner',
  'Zigeunerin',
  'Zigeunerkapelle',
  'Zigeunerlager',
  'Zigeunerleben',
  'Zigeunermusik',
  'Zigeunerprimas',
  'Zigeunerschnitzel',
  'Zigeunersprache',
  'Zigeunertonleiter',
  'Zigeunerwagen',
  'Zigeunerwirtschaft',
  'Zimtzicke',
  'Zimtziege',
  'Zitze',
  'Zuchthaus',
  'züchtigen',
  'Zwergenwerfen',
  'zwergenwüchsig',
  'Zwergewerfen',
  'Zwergin',
];
// Create fuzzy Krupion words
// But we want to allow HANS, so we can't create *NS*
export const badWordsKrupionFuzzy = badWordsKrupion.map((word: string) => {
  if (word.length > 3) {
    return `*${word.toLowerCase()}*`;
  }
  return word.toLowerCase();
});

export const badWordsFuzzyDe = [
  '*ana+l*',
  '*a+r+sch*',
  '*fi+ck*',
  '*hure*',
  '*kack*',
  '*lumm+el*',
  '*moese*',
  '*porn*',
  '*scheis+z*',
  '*scheis+s*',
  'schwanz*',
  '*tit+t*',
  '*vögel*',
  '*voegel*',
  '*wichs*',
  '*wix*',
  '*zigeuner*',
  '*trottel*',
  '*afd*',
  '*alice*',
  '*weidel*',
  '*alternative*',
  '*höcke*',
  '*hocke*',
  '*hocke*',
  '*gauland*',
  'alles für deutschland',
];

export const badWordsEn = [
  'fakk',
  'fuck',
  'fucker',
  'nigger',
  'neger',
  'niggr',
  'anilingus',
  'anus',
  'arse',
  'asshole',
  'bdsm',
  'ballgag',
  'ballsack',
  'bastard',
  'biatch',
  'bitch',
  'blowjob',
  'boner',
  'boob',
  'bullshit',
  'butt',
  'butthole',
  'buttplug',
  'cawk',
  'cawks',
  'clit',
  'clitoris',
  'cock',
  'cocksucker',
  'cockface',
  'cockhead',
  'cum',
  'crap',
  'cumdumpster',
  'cumdump',
  'cumwipe',
  'cunilingus',
  'cunnilingus',
  'cunillingus',
  'cunnillingus',
  'cunt',
  'cuntlicker',
  'damn',
  'dick',
  'dickhead',
  'dicks',
  'dickweasel',
  'dike',
  'dikes',
  'dildo',
  'dildos',
  'douchebag',
  'dyke',
  'dykes',
  'escort',
  'fag',
  'faggot',
  'fagat',
  'fagget',
  'faggit',
  'foreskin',
  'fuk',
  'fecal',
  'gangbang',
  'gobshit',
  'goddam',
  'goddamn',
  'godam',
  'goddam',
  'gook',
  'hardon',
  'hooker',
  'horny',
  'horseshit',
  'idiot',
  'lesbo',
  'masturbate',
  'nazi',
  'nazis',
  'naziz',
  'kunt',
  'kunts',
  'paedophil',
  'pedofil',
  'phuck',
  'piss*',
  'pussy',
  'shemale',
  'slut',
  'slutty',
  'strapon',
  'swinger',
  'turd',
  'twat',
  'vagina',
  'wanker',
  'wank',
  'wetback',
  'whore',
];

export const badWordsFuzzyEn = [
  '*fakk*',
  '*fuck*',
  '*fuk+er',
  '*fuk+ers',
  '*fukk*',
  '*ni+g+er*',
  '*testical*',
  '*testicle*',
  'anal',
  'anil+ingus*',
  'anus',
  'anuses',
  'anusez',
  'ar+se',
  'ar+sebadger',
  'ar+sehead*',
  'ar+sehol*',
  'ashol*',
  'ass+',
  'ass+hol',
  'ass+hole*',
  'ass+wipe',
  'aswipe',
  'az+hol',
  'az+hole*',
  'b_d_s_m',
  'ball+bag*',
  'ball+sack*',
  'bastard*',
  'bbc',
  'bellend',
  'biatch*',
  'bitch*',
  'blow_job*',
  'boff+in*',
  'bol+ock+*',
  'bon+er',
  'boo+b',
  'boo+bs',
  'boo+bz',
  'btch',
  'bugg+er*',
  'bul+shit*',
  'butt+',
  'butt+hol',
  'butt+hole*',
  'butt+much*',
  'butt+plug*',
  'carpet_muncher*',
  'cawk',
  'cawks',
  'clit+',
  'clit+er*',
  'clit+or*',
  'clit+s',
  'clit+z',
  'cock',
  'cock_sucker*',
  'cock_suckin*',
  'cockface*',
  'cockhead*',
  'cockmunch*',
  'cocknose*',
  'cocks',
  'cocks_sucker*',
  'cockwomble',
  'cockz',
  'crap',
  'cum',
  'cum+er',
  'cum+ing',
  'cumbub+le*',
  'cumdumpst*',
  'cumshot*',
  'cumwipe',
  'cun+il+ingus*',
  'cunt+',
  'cuntlick*',
  'cuntpud+le',
  'damn*',
  'dick',
  'dickhead*',
  'dicks',
  'dickwe+d*',
  'dickweasel',
  'dike',
  'dikes',
  'dil+do*',
  'dog+ie_styl*',
  'dog+y_styl*',
  'douche_bag',
  'douche_bags',
  'dupa',
  'dyke',
  'dykes',
  'ejackulate',
  'erotic*',
  'escort*',
  'fackin*',
  'fag',
  'fagat',
  'faget',
  'fagg+ot*',
  'fagget',
  'faggit',
  'faggt',
  'fagt',
  'fan+yflap*',
  'fatass*',
  'feasting',
  'fecal',
  'fingerfack*',
  'foreskin*',
  'fuk',
  'fuk+ah',
  'fuk+in*',
  'fy',
  'gang+_b+ang*',
  'get_laid',
  'gobshit+*',
  'god+am',
  'god+amn*',
  'godsd+am',
  'godsd+amn*',
  'gook',
  'got_laid',
  'hard_on',
  'hoer',
  'hooker*',
  'hore',
  'horny',
  'horsesh+it+',
  'idiot*',
  'j_o_i',
  'jack_as+',
  'jack_off',
  'jack_sh+it+',
  'jap',
  'japs',
  'jerk_off',
  'jiz+_stain',
  'jiz+breath',
  'jiz+cock',
  'joi',
  'kike',
  'kinky',
  'klit',
  'knob',
  'knobbing',
  'knobhead*',
  'kunt',
  'kunts',
  'kuntz',
  'ladyboy*',
  'lesbo',
  'masturbat*',
  'milf',
  'nazi',
  'nazis*',
  'naziz',
  'negr',
  'neo_nazi+',
  'ni+g+r',
  'ni+g+rs',
  'ni+gg+',
  'nimphoman*',
  'nip+le',
  'nip+les',
  'nutsack*',
  'nutsuck*',
  'orgas+m',
  'orgas+mo',
  'paedofil*',
  'paedophil*',
  'pedofil*',
  'pedophil*',
  'penis*',
  'phuck*',
  'pimp',
  'pimpis',
  'pimps',
  'pimpz',
  'pis+flap*',
  'pis+ing',
  'pis+wizard',
  'piss+',
  'porn',
  'porno',
  'prick+',
  'puss+e',
  'puss+y',
  'quim',
  'rape',
  'raping',
  'rectum',
  'redneck*',
  's.o.b',
  'sadism*',
  'semen',
  'sh+-it+',
  'sh+it+',
  'sh+it+e',
  'sh+it+y',
  'sh+it_hol*',
  'shemale*',
  'shit+bag*',
  'shit+house',
  'shit+magnet',
  'shit+pouch',
  'skanck',
  'skank',
  'slut+',
  'slut+y',
  'strap_on',
  'suicid*',
  'svastik*',
  'swastik*',
  'swinger',
  'threesome',
  'thundercunt*',
  'tit+',
  'tit+ie',
  'tit+ies',
  'tit+s',
  'tit+ywank',
  'todger',
  'turd',
  'twat',
  'twat+waf+l*',
  'twathead*',
  'twatty*',
  'twunt',
  'twunter',
  'vagina*',
  'viagra*',
  'vibrator',
  'voyeur*',
  'voyuer*',
  'vul+va*',
  'wank',
  'wanker*',
  'wankface',
  'wetback*',
  'whoar',
  'whore',
  'wiseass+',
  'wtf',
  'xrated',
  'zo+phil+i*',
];

export const badWords = [].concat.apply([], [badWordsDe, badWordsEn, badWordsKrupion]);
export const badWordsFuzzy = [].concat.apply(
  [],
  [badWordsDe, badWordsEn, badWordsKrupionFuzzy, badWordsFuzzyDe, badWordsFuzzyEn]
);

let badPhoneticsDict = {};
for (let word of [].concat.apply([], [badWordsDe, badWordsKrupion])) {
  let score = colognePhonetic(word);
  if (Object.keys(badPhoneticsDict).indexOf(score) > -1) {
    badPhoneticsDict[score].push(word);
  } else {
    badPhoneticsDict[score] = [word];
  }
}

export const badPhonetics = Object.keys(badPhoneticsDict);

profanity.addWords(badWords);

const badWordsNextData = {
  id: 'de',
  words: badWordsFuzzy,
  lookalike: {
    u: 'ü',
    o: 'ö',
    a: 'ä',
    ß: 's',
    ü: 'u',
    ö: 'o',
    ä: 'a',
    // ???
    // 'oe': 'o',
    // 'ae': 'a',
    // 'ue': 'u',
    $: 's',
    '@': 'a',
    '<': 'c',
    '!': 'i',
    '+': 't',
    '0': 'o',
    '1': 'i',
    '2': 'z',
    '3': 'z',
    '4': 'a',
    '5': 's',
    '8': 'b',
  },
};

export const colognePhoneticsLookalike = {
  $: 's',
  '@': 'a',
  '<': 'c',
  '!': 'i',
  '|': 'l',
  '+': 't',
  '0': 'o',
  '1': 'i',
  '2': 'z',
  '3': 'z',
  '4': 'a',
  '5': 's',
  '8': 'b',
};

export const badEmojis = ['🖕', '🍆', '🍑', '💦', '🍌', '🤬'];

const badwordsNext = new BadWordsNext({ data: badWordsNextData });

@Injectable({
  providedIn: 'root',
})
export class BadwordsService {
  simpleCheck(value: string) {
    const profanity_result = profanity.exists(value.replace(/\s/g, ''));
    const fuzzy_result = this.fuzzyCheck(value);
    const phonetics_result = this.phoneticsCheck(value);
    // console.log(`simpleCheck()ing "${value}": profanity ${profanity_result}, fuzzy ${fuzzy_result}, phonetics ${phonetics_result}`);
    return profanity_result;
  }

  fuzzyCheck(value: string) {
    // Check with and without spaces.
    const res = badwordsNext.check(value) || badwordsNext.check(value.replace(/\s/g, ''));
    // console.log(`fuzzyCheck()ing "${value}": ${res}`);
    return res;
  }

  phoneticsCheck(value: string) {
    // *****************************
    // The phonetics check has too many false negatives and blocks way to may good names.
    // So we remove it for now (2024-09-19).
    // Words like "Otze" was blocked, but "OtzeSamsungFF" or "OtzeSamsungChrome" was not blocked.
    // Also a lot of normal names like "karina", "chaos", "Hansi", "fritzegrimm", "ZufriedeneStraße4", "Hajo",... were blocked.
    // *****************************

    // let replaced = value;
    // for (const [what, replacement] of Object.entries(colognePhoneticsLookalike)) {
    //   replaced = replaced.replaceAll(what, replacement);
    // }
    // let words = replaced.replaceAll(/[^a-zA-ZäüöÄÜÖ]/gi, '|').split('|');
    // for (const word of words) {
    //   let score = colognePhonetic(word);
    //   if (badPhonetics.indexOf(score) > -1) {
    //     // console.log(`phoneticsCheck()ing "${word}":`, true);
    //     // console.log(`phoneticsCheck() for word "${word}" with score ${score} matched. Badwords with this score:`, badPhoneticsDict[score]);
    //     return true;
    //   } else {
    //     // console.log(`phoneticsCheck()ing "${word}":`, false);
    //   }
    // }
    return false;
  }

  emojiCheck(value: string) {
    const res = badEmojis.some((t) => value.indexOf(t) > -1);
    // console.log(`emojiCheck()ing "${value}": ${res}`);
    return res;
  }
}
